module.exports = __webpack_public_path__ + "static/img/Bells-Hotel.dca295c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Bells-Hotel.jpg
// module id = anYK
// module chunks = 0